<template>
    <div>
        <label class="dafault-checkbox">
            <span :class="{'active': val == value}">
                <img v-show="isChecked" :src="checkedImg" alt="">
            </span>
            <input type="radio" :value="val" v-model="checked" @change="onChange" />
            {{checkboxMsg}}
        </label>
    </div>
</template>
<script>
export default {
    name: 'rentCheckbox',
    data () {
        return {
            isChecked: this.isPropChecked,
            checkVal: '',
            checkedImg: require('@/assets/img/component/widge/checkbox/tick_white.svg'),
        }
    },
    props: {
        checkboxMsg: String,
        borderColor: String,
        bgColor: String,
        tickColor: String,
        val: '',
        value: '',
        isPropChecked: {
            default: true,
            type: Boolean
        },
        setDefault: Boolean
    },
    watch: {
        isPropChecked: function (val) {
            this.isChecked = val
        },
        setDefault: function () {
            if(this.setDefault){
                this.isChecked = this.setDefault
            }
        }
    },
    computed: {
        checked: {
            get () {
                return this.value
            },
            set (val) {
                this.checkVal = val
            }
        }
    },
    methods: {
        onChange: function(e) {
            this.isChecked = true;
            this.$emit('input', this.checkVal)
        }
    }
}
</script>
<style   lang="scss">
    .dafault-checkbox{
        position: relative;
        display: flex;
        align-items: center;
        font-size: 14px;
        cursor: pointer;
        color: #525956;
        font-weight: 300;
        span{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 20px;
            height: 20px;
            font-weight: 300;
            margin-right: 8px;
            border-radius: 3px;
            border: solid 1px #cacfcd;
            background-color: #ffffff;
        }
        span.active{
            border: solid 1px #ff9275;
            background-color: #ff9275;
        }
        input{
            display: none;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/widge/DefaultRadio.vue